import React from "react";
import { solutionsData } from "../../data/solutions";
import image from "../../images/hero_sol.jpg";
import MainFeaturedPost from "../../components/ImageComponent/MainFeaturedPost";
import SolutionsLayout from "../../layouts/SolutionsLayout";
import { Container } from "@material-ui/core";
import MasonryProductList from "../../components/ProductsList/MasonryProductList";

const SolutionsPage = () => {
	return (
		<SolutionsLayout title="Solutions">
			<MainFeaturedPost
				post={{
					title: "Real-time solutions, endless opportunities",
					description: `Games, Film, Automotive, AEC, Gambling, and more. Forged in gaming, Unity's flexible real-time tools offer incredible possibilities for all
									industries and applications.`,
					image: image,
					imgText: "main image description",
					
				}}
			/>
			
<Container>
		
		<MasonryProductList data={solutionsData} />
			</Container>
		</SolutionsLayout>
	);
};
export default SolutionsPage;
